import React from "react";

const Marquee = () => {
  const items = Array.from({ length: 10 }).map((_, i) => (
    <span key={i}>
      VENDA SEM APARECER <span className="vsa">VSA</span>
    </span>
  ));
  return (
    <div className="marquee">
      <div className="marquee-track">
        {items}
        {items}
      </div>
    </div>
  );
};

export default Marquee;
